import { InjectionToken, Provider } from '@angular/core';
import { Storage } from '@core/services/storage';

export const LOCAL_STORAGE_TOKEN = new InjectionToken<Storage>('LocalStorage');

export function provideStorage(): Provider[] {
  return [
    { provide: LOCAL_STORAGE_TOKEN, useValue: localStorage },
    { provide: Storage, useClass: Storage, deps: [LOCAL_STORAGE_TOKEN] }
  ];
}
